import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

export const getVersion = async (): Promise<string> => {
  const { data }: { data: string } = await axios.get(
    `https://portal.lptapps.com/api/software/8/current_version`
  );
  return data as string;
};

type QueryFnType = typeof getVersion;

type UseVersionOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useVersion = ({ config }: UseVersionOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['version'],
    queryFn: () => getVersion(),
    ...config,
  });
};
